<template>
  <div class="video-wrap">
    <!-- 用户信息 -->
    <transition name="slide-up">
      <div v-if="show && userData.userId" class="user-box">
        <div class="mongolia" :class="showType"></div>
        <div class="user">
          <a v-if="userData.userId" onclick="LXAnalytics('moduleClick', 'b_mw77r9gk');" :href="(isDPAPP ? 'dianping://user?userid=' : 'https://evt.dianping.com/synthesislink/13791.html?userid=') + userData.userId"></a>
          <div class="avatar">
            <div class="pic"><img v-if="userData.avatar" :src="userData.avatar"></div>
            <span v-if="userData && userData.userLevel"><img :src="'https://p0.meituan.net/gpa/roundlv' + userData.userLevel + '.png'" class="i-level"></span>
          </div>
          <div class="cont">
            <div class="tit">
              <h3>{{ userData.userNickName }}</h3>
              <template v-if="parseInt(userData.isVip) > 0">
                <span><img src="https://p0.meituan.net/gpa/v.png" class="i-vip"></span>
              </template>
              <template v-else-if="parseInt(userData.isVip) == 0">
                <span><img src="https://p0.meituan.net/gpa/grayv.png" class="i-vip"></span>
              </template>              
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div v-show="isVideoInited" class="video-box"  :class="isFullHeight ? 'full-height' : envType">
      <div class="video-play">
        <video id="topic_video" :src="video.src" preload="auto" width="1" height="1"></video>
        <template v-if="!isShowVideo">
          <a class="video-mask" @click="playVideo()">
            <img id="post_img" :src="video.poster">
            <i></i>
          </a>
        </template>
      </div>
    </div>
    <!-- 门店信息 & 评论 -->
    <transition name="slide-down">
      <div v-if="show" class="shop-info" :class="showLogo">
        <div class="mongolia" :class="showType"></div>
        <div v-if="comment.length" class="comment"><p>{{ comment }}</p></div>
        <div v-if="shopData.shopId" class="shop-box">
          <a onclick="LXAnalytics('moduleClick', 'b_qzckam19');" :href="(isDPAPP ? 'dianping://shopinfo?id=' : 'https://evt.dianping.com/synthesislink/13792.html?shopid=') + shopData.shopId"></a>
          <div v-if="shopData.picture" class="pic" :style="'background-image: url(\'' + fixImgUrl(shopData.picture) +  '\');'"></div>
          <div class="cont">
            <h4>{{ shopData.shopName }}{{ shopData.branchName ? '(' + shopData.branchName + ')' : '' }}</h4>
            <p>{{ shopData.shopRegion }} {{ shopData.shopCategory }} {{ shopData.avgPrice ? '￥' + shopData.avgPrice + '/人' : '' }}</p>
          </div>
        </div>
      </div>
    </transition>
    <toast :isShow="isShowToast" :msg="toastMsg" />
  </div>
</template>
<script>
import Util from '../libs/util'
import fecthData from '../libs/fetchData'
import OwlPerformance from '../libs/owl-performance'
import toast from './toast.vue'
import getUA from '@dp/util-m-ua'
import KNB from '@dp/knb'
const IScroll = require('../libs/iscroll-lite.js')
const Cookie = require('@dp/cookie')

const latestVersion = '9.3.0'
export default {
  name: 'user-share-video',
  data() {
    return {
      video: {
        src: '',
        poster: '',
        width: 0,
        height: 0,
        duration: 0
      },
      videoRatio: 0,
      userData: {},
      shopData: {},
      comment: '',
      bizId: 0,
      show: true,
      isShowVideo: false,
      toastMsg: '',
      isShowToast: false,
      isComplated: false,
      currentTime: 0,  // 当前播放时间点
      intervalTimer: 0,
      toOverTime: 1000, // 毫秒
      timer: '',
      isVideoInited: false,
      osName: getUA().os,
      isDPAPP: getUA().type == 'dpapp',
      envType: getUA().type,
      showLogo: 'no-logo',
      showType: 'width-s',
      isSquare: false,      
      isFullHeight: false,
      videoId: 0,
      isInitIscroll: false,
      isPlayCount: true, // 记录播放

      networkType: '',
      dpId: '',
      version: getUA().version || '',
      appType: getUA().type === 'dpapp' ? 'DPH5' : getUA().type === 'mtgroup' ? 'MTH5' : 'H5',

      totalPlayDuration: 0,
      isFirstPlay: true,
      initDate: null
    }
  },
  components: {
    toast
  },
  created() {
    let vm = this
    this.isShowToast = true
    this.loadData()
    this.dpId = Cookie('_lxsdk_cuid')
    let KNBP = KNB.getPromiseInstance()
    KNBP.all([KNBP.getUserInfo(), KNBP.getNetworkType()]).then(res => {
      console.log('knbp then')
      let user = res[0]
      let network = res[1]
      vm.dpId = user.uuid
      vm.networkType = network.networkType  //'2g','3g','4g','wifi',undefined
    })
    KNB.ready(function () {
      KNB.setLLButton({
        icon: 'H5_Back',
        handle: function () {
          console.log('LLButton click')
          vm.recordTotalPlayDuration()
          KNB.closeWebview()
        },
        success: function () {
          console.log('set LLButton success')
        },
        fail: function () {
          console.log('set LLButton fail')
        }
      })
    })
  },
  watch: {
    isComplated(value) {
      if (value && this.isShowVideo) {
        this.isShowVideo = false
        this.isComplated = false
      }
    }
  },
  updated: function() {
    if (!this.isInitIscroll) {
      let commentScroll = new IScroll('.comment', { scrollbars: 'custom' })
      this.isInitIscroll = true
    }    
  },
  methods: {
    loadData() {
      let vm = this
      let $ = require('jquery')
      vm.bizId = Util.getQueryString('bizId')
      fecthData.getdata({
        method: 'GET',
        urlname: 'getShareVideoInfo',
        data: {
          bizId: vm.bizId
        }
      }).then(function (data) {
        if (data.code !== 200) {
          vm.toastMsg = data.code == 402 ? 'Oops！找不到这条视频了' : '网络环境不佳，请刷新页面重试'
          return
        }
        vm.showLogo = ''
        vm.isShowToast = false
        vm.videoId = data.videoId
        vm.video.src = vm.fixImgUrl(data.keyUrl)
        vm.video.poster = vm.fixImgUrl(data.coverUrl)
        vm.video.width = data.width
        vm.video.height = data.height
        vm.video.duration = data.duration
        vm.videoRatio = vm.video.width / vm.video.height
        vm.shopData = data.shopInfo
        vm.shopData.shopId = data.shopId
        vm.userData = data.userInfo
        vm.comment = data.text
        vm.isVideoInited = vm.video.src.length
        vm.processVideo()
        vm.configShare()
        // $('video').attr('playsinline', 'true');
        // $('video').attr('webkit-playsinline', 'true')
        // console.log('width: ', $(window).width())
        // console.log('height: ', $(window).height())
        let windowRatio = $(window).width() / $(window).height()
        console.log('v', vm.videoRatio)
        console.log('w', windowRatio)
        if (windowRatio > vm.videoRatio) {
          $('.video-play').width('100%')
          $('.video-play').height($(window).height())
        } else {
          $('.video-play').width('100%')
        }

        vm.$nextTick(() => {
          // owl 性能上报
          OwlPerformance()
        })
      })
    },
    processVideo() {
      let vm = this
      let $ = require('jquery')
      let playCountTimer = null
      
      vm.$nextTick(function () {
        let video = document.getElementById('topic_video')

        video.addEventListener('playing', function () {
          vm.show = false
          vm.isShowVideo = true

          if (vm.osName != 'ios' || vm.envType === 'browser') {
            console.log(vm.osName, vm.envType)
            $('video').attr('width', '100%')
            $('video').attr('height', '100%')
          }

          $('video').attr('controls', true)
          // vm.isPlayCount = false

          let i = 0
          !vm.timer && (vm.timer = setInterval(function() {
            console.log((i++) + ' play cur time: ', video.currentTime)

            if (video.currentTime + 0.3 > (video.duration || vm.video.duration)) {
              $('video').attr('width', '1')
              $('video').attr('height', '1')
              vm.isShowVideo = false
              // vm.isPlayCount = true     
              window.clearInterval(vm.timer)
              vm.timer = null
            }
          }, 300))
        })

        video.addEventListener('pause', function () {
          console.log('pause')
          vm.isShowVideo = false
          vm.show = true
          $('video').attr('width', '1');
          $('video').attr('height', '1');
          $('video').attr('controls', false);
          window.clearInterval(vm.timer)
        })

        video.addEventListener('ended', function () {
          console.log('end')
          vm.isShowVideo = false
          vm.isPlayCount = true
          vm.show = true  
          // vm.totalPlayDuration += Math.ceil(vm.video.duration || video.duration)
        })

        video.addEventListener('timeupdate', function (e) {
          let currentTime = video.currentTime
          console.log('currentTime', video.currentTime)

          if (vm.isPlayCount && currentTime > 0) {
            vm.isPlayCount = false
            if (vm.isFirstPlay) {  // 统计播放次数
              vm.isFirstPlay = false
              fecthData.getdata({
                method: 'post',
                urlname: 'smallVideoPlayCount',
                data: {
                  id: vm.videoId,
                  netType: vm.networkType,
                  dpId: vm.dpId,
                  platform: vm.osName,
                  version: vm.version,
                  appType: vm.appType,
                  source: 'share_video',
                  duration: 0
                }
              }).then(function (res) {
                if (res.code == 200 && res.data) {
                  console.log('playcount success')
                }
              })
            }
          }

          // 播放时长计数
          if (currentTime > 0) {
            if (!playCountTimer) {
              vm.initDate = new Date()
            } else {
              clearTimeout(playCountTimer)
            }
            playCountTimer = setTimeout(() => {
              let endDate = new Date()
              vm.totalPlayDuration += (endDate - vm.initDate - 1000)
              console.log('totalPlayDuration', vm.totalPlayDuration)
              vm.initDate = null
              playCountTimer = null
            }, 1000)
          }
        })
        
        function setImgShow(vWidth, vHeight) {
          console.log(vWidth, vHeight)
          vm.isFullHeight = (vWidth / vHeight) < 1  // 全屏
          vm.isSquare = (vWidth / vHeight) === 1  // 正方形

          let vRatio = (vWidth / vHeight)
          if (vRatio > 1) {
            vm.showType = 'width-l'
          } else if ( vRatio <= 1) {
            vm.showType = 'width-s'
          }
        
          if (vWidth == 0 || vHeight == 0) {
            console.log(vWidth, vHeight)
            vm.isSquare = true
            vm.isFullHeight = false;
            vm.showType = 'width-s'
          }

          if (vm.isFullHeight) vm.showType = 'width-l'

          console.log('square: ', vm.isSquare)
          vm.isVideoInited = true
          vm.isShowToast = false
        }

        let postImg = new Image()

        postImg.onload = function() {
          let vWidth, vHeight
          console.log('i-succ')
          console.log('type', vm.envType)
          console.log('loadImg', postImg.width, postImg.height)
          vWidth = postImg && postImg.width
          vHeight = postImg && postImg.height

          setImgShow(vWidth, vHeight)
        }

        postImg.onerror = function() {
          let vWidth, vHeight
          console.log('i-err')
          vWidth = vm.video.width
          vHeight = vm.video.height
          setImgShow(vWidth, vHeight)
        }

        postImg.src = vm.video.poster
      })
    },
    playVideo() {
      LXAnalytics('moduleClick', 'b_e4wpi0ky');
      document.getElementById('topic_video').play()
    },
    fixImgUrl(img) {
      return img && img.indexOf('http://') !== -1 ? img.replace('http://', 'https://') : img;
    },
    configShare() {
      let vm = this
      let Share = require('@dp/util-m-share');
      return new Share({
        title: '我在大众点评发现了不错的内容~',
        desc: vm.comment ? vm.comment : 'https://www.dianping.com',
        url: window.location.href,
        image: vm.fixImgUrl(vm.video.poster),
        content: '我在大众点评发现了不错的内容',
        channelDPApp: [Share.CHANNEL.WECHAT_FRIENDS, Share.CHANNEL.WECHAT_TIMELINE],
        channelWX: [Share.CHANNEL.WECHAT_FRIENDS, Share.CHANNEL.WECHAT_TIMELINE],
        channelBrowser: [Share.CHANNEL.WEIBO, Share.CHANNEL.WEIBO_TECENT],
        channelQQ: [Share.CHANNEL.WECHAT_FRIENDS],
        handle: function () { },
        success: function () { console.log('share success'); },
        fail: function () { console.log('share failed'); },
        cancel: function () { console.log('share canceled'); }
      }, {
        hide: false
      })
    },
    recordTotalPlayDuration () {   // 统计播放时长
      if (this.totalPlayDuration === 0 && !this.initDate) {   // 未播放过视频，不上报播放时长
        return
      }
      let video = document.getElementById('topic_video')
      fecthData.getdata({
        method: 'post',
        urlname: 'smallVideoPlayCount',
        data: {
          id: this.videoId,
          netType: this.networkType,
          dpId: this.dpId,
          platform: this.osName,
          version: this.version,
          appType: this.appType,
          source: 'share_video',
          duration: this.initDate ? Math.ceil((new Date() - this.initDate + this.totalPlayDuration) / 1000) : Math.ceil(this.totalPlayDuration / 1000)
        }
      }).then((res) => {
        if (res.code == 200 && res.data) {
          console.log('播放时长 统计成功')
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// userShareVideo.vue?757440e3